import React, { useId } from 'react';
import { Input, Label } from 'reactstrap';
import { discountAmount } from '../../helpers/purchaseDiscount';
import { formatPrice } from '../../helpers/utility';

export default function PurchaseDiscount({ formik, disabled = false }) {
    const id = useId();
    const { values, setValues } = formik;
    const mode = values.modeRemise || 'MONTANT';
    const value = values.valeurRemise ?? values.montantRemise ?? 0;
    const update = (nextMode, nextValue) => {
        const total = Number(values.montantTotalAvantRemise ?? values.montantTotalTTC) || 0;
        const amount = discountAmount(total, nextMode, nextValue);
        setValues(current => ({ ...current, modeRemise: nextMode, valeurRemise: nextValue,
            montantRemise: amount, montantTotalTTC: Math.max(0, Math.round((total - amount) * 100) / 100) }));
    };
    return <div className="purchase-discount">
        <div><Label for={`${id}-mode`}>Remise du fournisseur</Label>
            <Input id={`${id}-mode`} type="select" value={mode} disabled={disabled} onChange={event => update(event.target.value, 0)}>
                <option value="MONTANT">En montant (DH)</option><option value="POURCENTAGE">En pourcentage (%)</option>
            </Input>
        </div>
        <div><Label for={`${id}-value`}>{mode === 'POURCENTAGE' ? 'Pourcentage à retirer' : 'Montant à retirer'}</Label>
            <Input id={`${id}-value`} type="number" min="0" max={mode === 'POURCENTAGE' ? 100 : undefined} step="0.01" value={value} disabled={disabled}
                onChange={event => update(mode, event.target.value === '' ? '' : Math.max(0, Math.min(Number(event.target.value) || 0, mode === 'POURCENTAGE' ? 100 : Infinity)))} />
        </div>
        <div className="align-self-end pb-2">Remise : <strong>{formatPrice(values.montantRemise || 0)}</strong></div>
    </div>;
}
